import type React from "react";

type Props = React.HTMLAttributes<HTMLLegendElement> & {
	children: React.ReactNode;
};

export const Legend = ({ children, ...rest }: Props) => (
	<legend className="mb-2 text-left text-base font-bold" {...rest}>
		{children}
	</legend>
);
